<template>
  <div>
    <file-manager
      v-if="typeState === 'FILE_MANAGER'"
      :options="options"
      :default-path="actualPath"
      @open-stock-images="openStockImages"
      @open-image-generator="openImageGenerator"
      @choose-file="chooseFile"
      @close-file-manager="closeFileManager"
      @change-default-path="$emit('changeDefaultPath', $event)"
      @create-image="$emit('createImage')"
      @notify="$emit('notify', $event)"
      @items-deleted="$emit('items-deleted', $event)"
    ></file-manager>
    <stock-images
      v-if="typeState === 'STOCK_IMAGES' && options.pexelsApiKey"
      :default-path="defaultPath"
      :options="options"
      @back="backToFileManager"
      @chooseFile="chooseFile"
      @closeFileManager="closeFileManager"
      @notify="$emit('notify', $event)"
    ></stock-images>
  </div>
</template>

<script lang="ts" setup>
  import { FileOptions } from "../../../types/FileOptions";
  import { ref, defineAsyncComponent } from "vue";

  const FileManager = defineAsyncComponent(
    () => import("./FileManager/FileManager.vue")
  );
  const StockImages = defineAsyncComponent(
    () => import("./StockImages/StockImages.vue")
  );

  type TypeState = "FILE_MANAGER" | "STOCK_IMAGES" | "IMAGE_GENERATOR";
  const emit = defineEmits(["chooseFile", "closeFileManager", "changeDefaultPath", "createImage", "notify", "items-deleted"]);

  const props = defineProps<{
    options: FileOptions;
    actualPath: string;
  }>()

  const typeState = ref<TypeState>("FILE_MANAGER");
  const defaultPath = ref("/");

  function chooseFile(url: string) {
    emit("chooseFile", url);
    closeFileManager();
  }

  function backToFileManager() {
    typeState.value = "FILE_MANAGER";
  }

  function openStockImages(path: string) {
    defaultPath.value = path;
    typeState.value = "STOCK_IMAGES";
  }

  function openImageGenerator() {
    typeState.value = "IMAGE_GENERATOR";
  }

  function closeFileManager() {
    emit("closeFileManager");
  }
</script>
